import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components";
import { LIGHT_GRAY, NEAR_BLACK, NEAR_WHITE, WHITE } from "../../../config";
import { getRiskColorByNameAndSelect } from "../../../utils";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 85vh;
  min-width: 430px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 35px;
`;

export const CloseModal = styled(FontAwesomeIcon)`
  cursor: pointer;
`;

export const Title = styled.h2`
  text-align: center;
  color: ${WHITE};
`;

export const ModalBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 2rem 1rem 2rem;
  max-height: 50vh;
  overflow: auto;
`;

export const LinkedContainer = styled.div`
  width: max-content;
  padding: 6px;
  height: 36px;
`;

export const ButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem;
`;

export const ModalBox = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: NEAR_BLACK,
    border: "none",
    borderRadius: "1rem",
    padding: "0",
    width: "min-content",
    minWidth: "642px",
    maxWidth: "800px",
    overflow: "hidden",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
    zIndex: 5,
  },
};

export const Input = styled.input`
  height: 48px;
  padding: 1rem;
  background: ${NEAR_BLACK};
  border: 1px solid ${NEAR_WHITE};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 16px rgba(51, 51, 51, 0.08);
  color: ${NEAR_WHITE};
  width: 100%;
  outline: none;
  transition: 0.2s ease;
  font-size: 14px;

  &:focus {
    border-color: ${LIGHT_GRAY};
  }
`;

export const SearchContainer = styled.div<{ isBarrierLayoutAllowed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 6px;
  margin: 0.5rem 2rem 0;

  input {
    width: ${({ isBarrierLayoutAllowed }) => (isBarrierLayoutAllowed ? "60%" : "100%")};
    border-radius: 5px;
  }
`;

export const StatusFilterContainer = styled.div`
  width: 40%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-around;
  color: ${NEAR_WHITE};
  font-size: 14px;

  div {
    display: flex;
    align-items: center;
  }
`;

export const RiskBoxLinkedModal = styled.div<{ color?: string; active?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 3px;
  box-sizing: border-box;
  outline: none;
  user-select: none;
  margin-right: 0.5rem;
  background-color: ${({ color, active }) => getRiskColorByNameAndSelect(active, color)};
  cursor: pointer;
`;

export const StatusText = styled.span<{ active?: boolean }>`
  font-size: 12px;
  color: ${({ active }) => (active ? NEAR_WHITE : LIGHT_GRAY)};
`;
